<template>
  <Flex
    truncate
    grow
    flex-shrink-0
    justify-between
    whitespace-no-wrap
    class="content"
    px-1
    v-on="{
      ...node.dragListeners({ action: getDragAction }),
      ...node.dropListeners(),
    }"
    :class="{
      'divider-top': node.isActiveTarget() && dragAction === 'moveBefore',
      'divider-bottom': node.isActiveTarget() && dragAction === 'moveAfter',
    }"
  >
    <Flex>
      <Chip label>{{ index }}</Chip>
    </Flex>
    <div class="flex-1 truncate">
      {{ node.data.label }}
    </div>
    <Chip v-if="isInvalid" color="red" v-tooltip.top="'Contains Validation Errors'">!</Chip>
    <div draggable v-tooltip.right="'Drag to Reorder'" @dragend="onDragEnd">
      <Icon class="self-end p-1" src="material/drag_handle"> </Icon>
    </div>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon.vue'
import Chip from '@wizer/core/components/chip/Chip.vue'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'StateListItem',
  components: {
    Flex,
    Icon,
    Chip,
  },
  props: {
    node: Object,
    index: Number,
    isInvalid: Boolean,
  },
  data() {
    return {
      isActiveTarget: false,
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      dragAction: (state) => state.FormStatus.dragAction,
    }),
  },
  methods: {
    onDragEnd() {
      this.$store.dispatch('FormStatus/toggleEditorRefreshNeeded', { root: true })
    },
    // Custom drag action to support drag to reorder with left click
    getDragAction(e) {
      const first = _.castArray(e.source)[0]
      let dragAction
      if (first && first.parent === e.target.parent && e.target.index < first.index) {
        dragAction = 'moveBefore'
      } else {
        dragAction = 'moveAfter'
      }
      this.$store.dispatch('FormStatus/add', dragAction, { root: true })
      return dragAction
    },
  },
}
</script>

<style scoped>
.content {
  @apply flex items-center cursor-default pr-2 outline-none;

  &:hover,
  .w-tree-view-item--selected > & {
    @apply bg-gray-200;
  }
}
.w-chip {
  height: initial;
  @apply px-2 mr-1;
}
.divider-top {
  border-top: 2px;
  @apply border-solid border-gray-500;
}
.divider-bottom {
  border-bottom: 2px;
  @apply border-solid border-gray-500;
}
</style>
